/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type USER_ROLE = "ADMIN" | "COMMENTER" | "MEMBER" | "MODERATOR" | "STAFF" | "%future added value";
export type ModerationActionBanContainer_viewer = {
    readonly moderationScopes: {
        readonly scoped: boolean;
    } | null;
    readonly role: USER_ROLE;
    readonly " $refType": "ModerationActionBanContainer_viewer";
};
export type ModerationActionBanContainer_viewer$data = ModerationActionBanContainer_viewer;
export type ModerationActionBanContainer_viewer$key = {
    readonly " $data"?: ModerationActionBanContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ModerationActionBanContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModerationActionBanContainer_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "UserModerationScopes",
            "kind": "LinkedField",
            "name": "moderationScopes",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "scoped",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = 'e9a168979fc2a7662477f2d46e46bc36';
export default node;
